'use strict';

const isDesktopView = require('./modules/helpers/isDesktopView');
const isTabletView = require('./modules/helpers/isTabletView');
const isRetina = require('./modules/helpers/isRetina');
const debounce = require('./modules/helpers/debounce');

function getImgSrc(img){
    const $img = img;
    const imgDesktop = $img.data('desktop-img');
    const imgTablet = $img.data('tablet-img');
    const imgMobile = $img.data('mobile-img');
    const imgDesktopRetina = $img.data('desktop-retina');
    const imgTabletRetina = $img.data('tablet-retina');
    const imgMobileRetina = $img.data('mobile-retina');
    let imgUrl;

    if (isRetina()){
        if (isDesktopView()) {
            imgUrl = imgDesktopRetina || imgDesktop;
        } else if (isTabletView()) {
            imgUrl = imgTabletRetina || imgTablet || imgDesktopRetina || imgDesktop;
        } else {
            imgUrl = imgMobileRetina || imgMobile || imgTabletRetina || imgTablet || imgDesktop;
        }
    } else {
        if (isDesktopView()) {
            imgUrl = imgDesktop || imgDesktopRetina;
        } else if (isTabletView()) {
            imgUrl = imgTablet || imgTabletRetina || imgDesktop || imgDesktopRetina;
        } else {
            imgUrl = imgMobile || imgMobileRetina || imgTablet || imgTabletRetina || imgDesktop || imgDesktopRetina;
        }
    }

    $img.attr('data-src', imgUrl);
}

function responsiveBgImg() {
    const $bgSwitch = $('.js-responsive-bg');

    if ($bgSwitch.length) {
        $bgSwitch.each(function () {
            // set correct image src
            getImgSrc($(this));
            // init lazy load
            $(this).lazy();
        });
    }
}

function initializeEvents() {
    responsiveBgImg();

    $(window).on('resize', debounce(function () {
        responsiveBgImg();
    }, 300));
}

const responsiveBg = {
    init: function() {
        initializeEvents();
    }
};

module.exports = responsiveBg;
